module.exports = __webpack_public_path__ + "static/media/nnfo - Copy.4628504f.jpg";